@if (safeIFrameSrc() !== null) {
  <iframe #loginIFrame [src]="safeIFrameSrc()"></iframe>
}
